import { SET_SIDEBAR_ENABLE }  from 'actions/types'

//Action Creators
export const setSidebarEnable = (enable) => {
    return { type:SET_SIDEBAR_ENABLE, enable:enable};
}
